//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['competition', 'region', 'date', 'isLive', 'type', 'mode', 'title', 'title-icon', 'hideSubtitles', 'hideEmpty'],
  data() {
    return {
      competitions: [],
      events: [],
      defaultFilter: null,
      selectedSports: [],
      selectedFilter: null,
      liveSports: [],
      filters: [],
      sportName: null,
      oddsVisible: false,
      loading: true
    }
  },
  computed: {
    sports() {
      let sports = _.get(this.$store.state, 'sports', [])
      sports = _.filter(sports, { category: 'esport' })
      sports = _.filter(sports, function (o) {
        return o.event_count > 0
      })
      return sports
    },
    isVisible() {
      if (this.competitions && this.competitions.length == 0) {
        return false
      }
      return true
    },
    sport() {
      return _.get(this.$store.state, 'inplay.sport')
    },
    event_id() {
      return _.get(this.$store.state, 'inplay.event_id')
    }
  },
  watch: {
  },
  mounted() {
    this.currentEvents = []
    this.loading = true
    this.getSports()
  },
  beforeDestroy: function () {
    console.log('CHANGE clear', this.type, this.sport, this.hash)

    tock.clear('events_widget_live' + this.hash)
    emitter.off('events')
  },
  methods: {
    async selectSport(sport) {
      this.selectedSports = _.xor(this.selectedSports, [sport.slug]);
    },
    async getSports() {
      this.$content()
        .get('home', { params: {lang: this.lang}})
        .then((response) => {
          // handle success
          response = _.get(response, 'data')
          this.liveSports = _.get(response, 'data.tabs.live')
          if( _.get(this.$store.state, 'inplay.sport') ) {
            this.selectedSports.push(  _.get(this.$store.state, 'inplay.sport') )
          }

        })
        .catch(function (error) {
          console.log(error) // handle error
        })
    },
    toggleOdds() {
      this.oddsVisible = !this.oddsVisible
    }
  }
}
